import React from "react";

function serviceState(application, { loading, stale, builtin = false, registered = true }) {
  if (loading) return { label: "Checking status", tone: "unknown" };
  if (stale && !builtin) return { label: "Status stale", tone: "unknown" };
  if (builtin) return { label: "Available", tone: "ready" };
  if (!registered) return { label: "Not in directory", tone: "muted" };
  if (!application) return { label: "Status unknown", tone: "unknown" };
  if (application.readiness === "BLOCKED") return { label: "Blocked", tone: "attention" };
  if (application.readiness === "DISABLED" || application.enabled === false) return { label: "Disabled", tone: "muted" };
  if (application.readiness === "NOT_READY") return { label: "Not ready", tone: "attention" };
  if (application.application_status === "NOT_INSTALLED") return { label: "Not installed", tone: "muted" };
  if (application.application_status === "NOT_STARTED") return { label: "Not started", tone: "attention" };
  if (application.application_status === "MAINTENANCE") return { label: "Maintenance", tone: "attention" };
  if (application.application_status === "UPGRADE_REQUIRED") return { label: "Upgrade required", tone: "attention" };
  if (application.application_status === "UNAVAILABLE") return { label: "Unavailable", tone: "attention" };
  if (application.entitled === true && application.enabled === true) return { label: "Configured", tone: "ready" };
  return { label: "Not linked", tone: "muted" };
}

function serviceInitial(name) {
  return String(name || "S").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase() || "S";
}

export default function ProfileServiceDirectory({
  applications = [],
  loading = false,
  stale = false,
  selectedId,
  onSelect,
}) {
  const catalog = [
    { id: "jellyfin", name: "Jellyfin", purpose: "Watch & Listen" },
    { id: "immich", name: "Immich", purpose: "Moments and photos" },
    { id: "nextcloud", name: "Nextcloud", purpose: "Files" },
    { id: "humhub", name: "HumHub", purpose: "Community" },
    { id: "grafana", name: "Grafana", purpose: "Observability" },
    { id: "portainer", name: "Portainer", purpose: "Container management" },
  ];
  const configured = new Map(applications.map((application) => [String(application.id || "").toLowerCase(), application]));
  const services = [
    { id: "hacams", name: "HACaMS", purpose: "Account identity and password", builtin: true },
    ...catalog.map((service) => ({
      ...service,
      application: configured.get(service.id),
      registered: configured.has(service.id),
    })),
    ...applications
      .filter((application) => !catalog.some((service) => service.id === String(application.id || "").toLowerCase()))
      .map((application) => ({
        id: String(application.id),
        name: application.name || application.id || "Application",
        purpose: application.purpose || "Connected application",
        application,
        registered: true,
      })),
    { id: "alerts", name: "Alerts", purpose: "Notification channels and subscriptions", builtin: true },
  ];
  const seen = new Set();
  const uniqueServices = services.filter((service) => {
    const id = service.id.toLowerCase();
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });

  return (
    <nav className="profile-service-directory" aria-label="Profile services">
      <div className="profile-panel-kicker">CONNECTED SERVICES</div>
      <h2 className="profile-panel-heading">Your services</h2>
      <p className="profile-panel-intro">Choose a service to view its account and available actions.</p>
      {loading && <p className="profile-directory-notice" role="status">Checking the configured service directory…</p>}
      {stale && !loading && <p className="profile-directory-notice" role="status">Service information is stale. Credential and launch actions are unavailable until refreshed.</p>}
      <div className="profile-service-list">
        {uniqueServices.map((service) => {
          const state = serviceState(service.application, { loading, stale, builtin: service.builtin, registered: service.registered });
          const selected = selectedId === service.id;
          return (
            <button
              key={service.id}
              type="button"
              className={"profile-service-item" + (selected ? " is-selected" : "")}
              aria-pressed={selected}
              onClick={() => onSelect(service.id)}
            >
              <span className="profile-service-monogram" aria-hidden="true">{serviceInitial(service.name)}</span>
              <span className="profile-service-copy">
                <strong>{service.name}</strong>
                <small>{service.purpose}</small>
                <span className="profile-service-mobile-state">{state.label}</span>
              </span>
              <span className={"profile-service-state profile-service-state-" + state.tone}>
                <span aria-hidden="true" />
                {state.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
